import {useQuery} from 'react-query'
import {deleteDriver, fetchDriverList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import DriverForm from './Form'
import toast, {Toaster} from 'react-hot-toast'
import ModalWithForm from '../../../components/ModalWithForm'
import {Button} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import WithModal from '../../../components/WithModal'
import ViewAll from '../../../components/ViewAll'
import NFC from './NFC'
import clsx from 'clsx'
import {KTIcon} from '../../../_metronic/helpers'
import MoreInfoLabel from '../../../components/MoreInfoLabel'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import PortalDropdown from '../../../components/PortalDropdown'
import EditLabel from '../../../components/EditLabel'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import DeleteLabel from '../../../components/DeleteLabel'
import DriverUpload from '../driver-upload/Index'
import TopBarProgress from 'react-topbar-progress-indicator'

const driverBreadcrumbs = [
  {
    title: 'User Management',
    path: 'users/driver',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function Driver() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery('driverList', fetchDriverList, {
    refetchOnWindowFocus: false,
  })

  if (isLoading) {
    return <Processing />
  }
  const cellModifier = {
    driver_status: ({value}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },
    authorized_vehicle: ({value}) => {
      if (Array.isArray(value)) {
        const authorizedVehicleFullForm = value.map((vehicleType) => {
          switch (vehicleType) {
            case 'hvd':
              return 'Heavy Vehicle Duty (HVD)'
            case 'lvd':
              return 'Light Vehicle Duty (LVD)'
            case 'medium':
              return 'Medium Truck'
            case 'bus':
              return 'Bus'
            default:
              return ''
          }
        })
        return authorizedVehicleFullForm.join(', ')
      }
      return ''
    },
    more: ({row}) => {
      const orderedFields = [
        ...Object.entries(viewProps.Driver.primaryFieldsToLabelMap),
        ...Object.entries(viewProps.Driver.secondaryFieldsToMap),
      ]
      return (
        <WithModal
          renderModalBody={() => (
            <ViewAll data={row.original} cellModifier={cellModifier} fieldOrder={orderedFields} />
          )}
          modalTitle={
            <span>
              Details of <span className="text-primary">{row.original.driver_name}</span>
            </span>
          }
          modalAttrs={{backdrop: true, size: 'lg'}}
        >
          <MoreInfoLabel />
        </WithModal>
      )
    },
    Actions: ({row}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={
                <span>
                  RFID of <span className="text-primary">{row.original.driver_name}</span>
                </span>
              }
              initialValues={row.original}
              Form={NFC}
              modalAttrs={{size: 'sm'}}
              onSubmit={refetch}
              triggerClassName="d-block"
            >
              <div className="px-3 py-2">
                <i
                  className={clsx(
                    'fa-brands fa-nfc-symbol fs-6',
                    row.original.nfc_code ? 'link-info' : 'link-secondary'
                  )}
                />
                <span className="ms-2">RFID</span>
              </div>
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Driver'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={DriverForm}
              modalAttrs={{size: 'lg'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteDriver(row.original.user_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }
  return (
    <>
      <Helmet>
        <title>TrackNAB | Drivers list</title>
      </Helmet>
      <PageTitle breadcrumbs={driverBreadcrumbs}>Driver</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.Driver}
          fieldToLabelMap={viewProps.Driver.primaryFieldsToLabelMap}
          Form={DriverForm}
          cellModifier={cellModifier}
          nonSortableColumns={['More Info', 'Actions']}
          headerExtras={
            <>
              <ModalWithForm
                modalTitle={'Add Driver'}
                triggerClassName="ms-auto"
                onSubmit={refetch}
                Form={DriverForm}
                modalAttrs={{size: 'lg'}}
              >
                <Button size="sm" className="me-4">
                  Add Driver
                </Button>
              </ModalWithForm>
              <ModalWithForm modalTitle={'Driver Upload'} onSubmit={refetch} Form={DriverUpload}>
                <Button
                  variant="light"
                  size="sm"
                  className="d-flex align-items-center gap-2 ps-4 pe-3 text-primary border border-primary rounded-3"
                >
                  <b>Upload</b>
                  <KTIcon iconName="file-up" className="fs-3 text-primary" />
                </Button>
              </ModalWithForm>
              {/* <ModalWithForm
                modalTitle={'NFC Upload'}
                onSubmit={refetch}
                Form={NFCUpload}
                initialValues={{type: 'driver'}}
              >
                <Button
                  variant="light"
                  size="sm"
                  className="d-block blockgap-2 ps-4 pe-3 text-primary border border-primary rounded-3 ms-4"
                >
                  <span>NFC Upload</span>
                  <KTIcon iconName="file-up" className="fs-3 text-primary" />
                </Button>
              </ModalWithForm> */}
            </>
          }
        />
      )}
      {isFetching && <TopBarProgress />}

      <Toaster />
    </>
  )
}

export default Driver
